/* eslint-disable import/no-cycle */
import React from 'react';
import  queryString  from 'query-string';
import { useNavigate, useLocation } from 'react-router';
import classes from './classes.module.scss';
import AppLink from '../../routes/app_link';
import { isKA, toCamelCase } from '../../../../common/config/utils';
import { SvgIcon } from '../../../../common/sprites';
import { seeMoreBtnThemes } from './index';
import PaginationPages from '../pagination_pages';

const getPage = (page) => {
  const search = toCamelCase(queryString.parse(window.location.search));
  const searchPage = typeof search.page !== 'undefined' && search.page;
  const usedPage = searchPage ? parseFloat(searchPage) : page;
  return { usedPage, searchPage };
};
const needRenderSeeMoreBtnDefault = ({ loading, lastPageNum }) => !loading && lastPageNum;

const renderSeeMoreBtnDefault = ({
  loading, lastPageNum, seeMoreBtnClick, t, theme, seenPages, page
}) => {
  if (!needRenderSeeMoreBtnDefault({ loading, lastPageNum })) return null;
  const { usedPage, searchPage } = getPage(page);
  if (!searchPage || usedPage === 1) {
    if (lastPageNum <= usedPage) return null;
    return (
      <div className={ classes.bottomButtonContainer } data-testid="see-more-btn-container">
        <button type="button" className={ classes.bottomButton } onClick={ seeMoreBtnClick }>
          { t('home_page.see_more') }
        </button>
      </div>
    );
  }
  return (
    <PaginationPages
      theme={ theme }
      lastPageNum={ lastPageNum }
      seenPages={ seenPages }
    />
  );
};

function SeeMoreBtn({
  theme = 'searchResult',
  loadAdvisors,
  loading,
  params,
  t,
  slug,
  seenPages = [],
  lastPageNum,
  page = 1
}) {
  const history = useNavigate();
  const location = useLocation();

  const seeMoreBtnClick = () => {
    const { usedPage, searchPage } = getPage(page);
    const nextPage = usedPage + 1;
    loadAdvisors();
    if (searchPage) {
      const srarch = queryString.parse(location.search);
      const searchWithPage = queryString.stringify({ ...srarch, page: nextPage });
      history(`${ location.pathname }?${ searchWithPage }`, {
        state: { ...location.state },
        replace: true
      });
    }
  };

  const renderSeeMoreBtnDefaultHomePageAllAdvisors = () => (
    <div className={ classes.bottomButtonContainer }>
      <AppLink
        to={ {
          pathname: slug,
          state: {
            needRefresh: true,
            params
          }
        } }
        style={ isKA() ? { padding: '10px 50px' } : {} }
        className={ classes.bottomButton }
      >
        {!isKA() && <div><SvgIcon id="see_more_btn" className={ classes.seeMoreBtnImg } /></div>}
        <span className={ classes.seeMoreBtnText }>
          { t('home_page.see_more_advisors') }
        </span>
      </AppLink>
    </div>
  );

  const renderSeeMoreBtn = () => {
    if (theme === seeMoreBtnThemes.homePageAllAdvisors) {
      return renderSeeMoreBtnDefaultHomePageAllAdvisors();
    }
    return renderSeeMoreBtnDefault({
      loading, lastPageNum, seeMoreBtnClick, t, theme, seenPages, page
    });
  };

  return (
    <div className={ classes[`${ theme }`] }>
      { renderSeeMoreBtn() }
    </div>
  );
}

export default SeeMoreBtn;
